
import axios from 'axios';
import { computed } from 'vue';
import {usePortalContentAndDesignStore} from "../../stores/partners/portalContentAndDesignStore";

export function useLogin(turnstileTokenRef = null) {

    const portalContentAndDesignStore = usePortalContentAndDesignStore();

    const getFormActionRoute = computed(() => {
        return portalContentAndDesignStore.loginPageSettings.is_otp_login
            ? route('partners_int.portal-login.otp.ini')
            : route('partners_int.portal-login.standard.login');
    });

    const turnstileEnabled = computed(() => portalContentAndDesignStore.turnstileSettings?.turnstile_enabled);

    const resetLoginErrors = () => {
        portalContentAndDesignStore.resetFormErrors('login');
    };

    const buildTurnstilePayload = (payload) => {
        if (turnstileTokenRef?.value) {
            payload['cf-turnstile-response'] = turnstileTokenRef.value;
        }
        return payload;
    };

    const standardLogin = () => {
        resetLoginErrors();
        portalContentAndDesignStore.loggingInProgress = true;

        const payload = buildTurnstilePayload({
            email: portalContentAndDesignStore.loginFormData.email,
            password: portalContentAndDesignStore.loginFormData.password,
            ...portalContentAndDesignStore.getHoneypotPayload,
        });

        axios.post(getFormActionRoute.value, payload)
            .then(response => {
                if (+response.data.status === 1) {
                    resetLoginErrors();
                    window.location.href = response.data.redirect_url;
                } else {
                    portalContentAndDesignStore.loginFormErrors.responseError = response.data?.error;
                    portalContentAndDesignStore.loginFormData.password = '';
                    document.getElementById('password')?.focus();
                }
            }).catch(error => {
            if (error.response && error.response.status === 422) {
                portalContentAndDesignStore.loginFormErrors.validationErrors = error.response?.data?.errors;
            } else {
                console.log('Login error:', error.response);
                portalContentAndDesignStore.loginFormErrors.responseError = error.response?.data?.error || 'An error occurred. See console for details.';
            }

            })
            .finally(() => {
                portalContentAndDesignStore.loggingInProgress = false;
            });
        };

    const initOtp = () => {
        resetLoginErrors();
        portalContentAndDesignStore.loggingInProgress = true;

        const payload = buildTurnstilePayload({
            email: portalContentAndDesignStore.loginFormData.email,
            ...portalContentAndDesignStore.getHoneypotPayload,
        });

        axios.post(getFormActionRoute.value, payload)
            .then(response => {
                if (+response.data.status === 1) {
                    resetLoginErrors();
                    portalContentAndDesignStore.loginFormData.otpIdentifier = response.data.otp_identifier;
                    portalContentAndDesignStore.loginFormData.otpIniSuccessMessage = response.data.otp_message;
                } else {
                    portalContentAndDesignStore.loginFormErrors.responseError = response.data?.error;
                    portalContentAndDesignStore.loginFormData.password = '';
                    document.getElementById('password')?.focus();
                }
            }).catch(error => {
                if (error.response && error.response.status === 422) {
                    portalContentAndDesignStore.loginFormErrors.validationErrors = error.response?.data?.errors;
                } else {
                    console.log('Login error:', error.response);
                    portalContentAndDesignStore.loginFormErrors.responseError = error.response?.data?.error || 'An error occurred. See console for details.';
                }
            })
            .finally(() => {
                portalContentAndDesignStore.loggingInProgress = false;
            });
        };

    const otpLogin = () => {
        resetLoginErrors();
        portalContentAndDesignStore.loggingInProgress = true;

        axios.post(route('partners_int.portal-login.otp.login'), {
            otp_identifier: portalContentAndDesignStore.loginFormData.email,
            otp_token: portalContentAndDesignStore.loginFormData.token,
            ...portalContentAndDesignStore.getHoneypotPayload,
        }).then(response => {
            if (+response.data.status === 1) {
                resetLoginErrors();
                window.location.href = response.data.redirect_url;
            } else {
                portalContentAndDesignStore.loginFormErrors.responseError = response.data?.error;
                portalContentAndDesignStore.loginFormData.token = '';
                document.getElementById('token')?.focus();
            }
        }).catch(error => {
            if (error.response && error.response.status === 422) {
                portalContentAndDesignStore.loginFormErrors.validationErrors = error.response?.data?.errors;
            } else {
                console.log('Login error:', error.response);
                portalContentAndDesignStore.loginFormErrors.responseError = error.response?.data?.error || 'An error occurred. See console for details.';
            }

        })
        .finally(() => {
            portalContentAndDesignStore.loggingInProgress = false;
        });
    };

    const submitLogin = () => {
        if (portalContentAndDesignStore.isPreview) {
            return;
        }
        const loginData = portalContentAndDesignStore.loginFormData;

        if (portalContentAndDesignStore.loginPageSettings.is_otp_login) {
            if (loginData.otpIdentifier && loginData.otpIniSuccessMessage) {
                otpLogin();
            } else {
                initOtp();
            }
        } else {
            standardLogin();
        }
    };

    return {
        submitLogin,
        initOtp,
        otpLogin,
        standardLogin,
        turnstileEnabled,
    };
}
